import {
  Button,
  DateBox,
  NumberBox,
  SelectBox,
  TextBox
} from 'devextreme-react';
import { formatMessage } from 'devextreme/localization';
import React, { useCallback } from 'react';
import { format } from 'date-fns';
import PopupMVP from '../../PopupMVP';
import styles from './searchBarFilter.module.scss';

const WrappedField = React.memo(({ children, component }) => (
  <div className={styles.fieldWrapper} key={component.name}>
    <div className={styles.fieldLabel}>
      {formatMessage('filters')[component.name]}
      :
    </div>
    {children}
  </div>
));

const SearchBarFilter = ({
  filterData, // выбранные фильтры для отправки на бэк
  setFilterData,
  filterConfig,
  onModalHiding,
  onModalReset,
  isFilterPopupVisible,
  onModalSave
}) => {
  // функция генерации полей для модального окна фильтров
  const createFilterComponents = useCallback(
    (config) => {
      const placeholderFilter = 'Не выбрано';
      const onValueChanged = (value, name) => {
        const configured = {
          ...filterData,
          [name]: value
        };
        setFilterData(configured);
        if (!value) {
          const removed = { ...filterData };
          delete removed[name];
          setFilterData(removed);
        }
      };
      const formatDate = (date, Format) => (date ? format(new Date(date), Format || 'dd.MM.yyyy') : '');
      return config.map((component) => {
        if (component.type === 'text') {
          return (
            <WrappedField key={component.name} component={component}>
              <TextBox
                onValueChanged={(e) => onValueChanged(e.value, component.name)}
                placeholder={placeholderFilter}
                stylingMode="underlined"
                value={filterData[component.name] || null}
                key={component.name}
                className={styles.filterField}
              />
            </WrappedField>
          );
        }
        if (component.type === 'number') {
          return (
            <WrappedField key={component.name} component={component}>
              <NumberBox
                onValueChanged={(e) => onValueChanged(e.value, component.name)}
                placeholder={placeholderFilter}
                stylingMode="underlined"
                value={filterData[component.name] || null}
                key={component.name}
                className={styles.filterField}
              />
            </WrappedField>
          );
        }
        if (component.type === 'array') {
          return (
            <WrappedField key={component.name} component={component}>
              <SelectBox
                placeholder={placeholderFilter}
                label={component.text}
                displayExpr="value"
                valueExpr="key"
                value={filterData[component] || null}
                onValueChanged={(e) => onValueChanged(component.options[e.value], component.name)}
                dataSource={Object.keys(component.options).map((el) => ({
                  key: el,
                  value: component.options[el]
                }))}
                stylingMode="underlined"
                key={component.name}
                className={styles.filterField}
              />
            </WrappedField>
          );
        }
        if (component.type === 'date') {
          return (
            <WrappedField key={component.name} component={component}>
              <DateBox
                placeholder={placeholderFilter}
                label={component.text}
                value={filterData[component.name] || null}
                displayFormat="dd.MM.yyyy"
                dateSerializationFormat="yyyy-MM-dd"
                onValueChanged={(e) => onValueChanged(formatDate(e.value, 'yyyy-MM-dd'), component.name)}
                stylingMode="underlined"
                key={component.name}
                className={styles.filterField}
              />
            </WrappedField>
          );
        }
        return null;
      });
    },
    [filterData, setFilterData]
  );

  return (
    filterConfig && (
      <PopupMVP
        visible={isFilterPopupVisible}
        title={formatMessage('searchBar').filterSettings}
        onHiding={onModalHiding}
      >
        <div className="formData">
          {createFilterComponents(filterConfig)}
          <div className="formButton">
            <Button
              type="default"
              stylingMode="contained"
              onClick={onModalSave}
              text={formatMessage('textButton').save}
            />
            <Button
              type="danger"
              stylingMode="contained"
              onClick={onModalHiding}
              text={formatMessage('textButton').cancel}
            />
            <Button
              type="danger"
              stylingMode="contained"
              onClick={onModalReset}
              text={formatMessage('textButton').reset}
            />
          </div>
        </div>
      </PopupMVP>
    )
  );
};

export default React.memo(SearchBarFilter);
